module.exports = __webpack_public_path__ + "img/42-min.68a55487.jpg";